jQuery(document).ready(function ($) {
  
  
  $('.provider_card').each(function(){
    var $value = $(this).find('.provider_line_speed_selector').val();
    $(this).find('.provider_card__price').html('R'+ $value + '<span class="per_month">per month</span>');
  });

  $('.provider_line_speed_selector').on('change', function(){
    var $parent = $(this).parents('.provider_card');
    var $value = $(this).val();
    $parent.find('.provider_card__price').html('R'+ $value + '<span class="per_month">per month</span>' );
  });


});